import { CSSProperties } from 'react'
import { Handle, HandleType, Position } from 'reactflow'
import { ConditionNode, GraphRoot, Node } from '@/api/dashboard'
import { Attribute, CAMPAIGN_ATTRIBUTES } from '@/expr/types'
import { EventActionNodeType } from '../types'
import { KeyValue } from '@/types'
import { findAttr } from '@/expr/findAttr'
export const IOHandleSize = 2

export function getLineColor() {
  return '#68C9E7'
}

export function getWarningLineColor() {
  return '#FF9F1C'
}

export function hasNextNode(graph: GraphRoot, node: Node): boolean {
  if (!graph.nodes) {
    return false
  }
  if (node.model_type == EventActionNodeType.ConditionNode) {
    let cn = node as ConditionNode
    return !!(cn.true_node_id && graph.nodes[cn.true_node_id]) || !!(cn.false_node_id && graph.nodes[cn.false_node_id])
  }

  return !!(node.next_node_id && graph.nodes[node.next_node_id])
}

export function isMoneyAttribute(attrName: string) {
  let attr = findAttr(attrName)

  if (!attr) {
    attr = Object.values(CAMPAIGN_ATTRIBUTES)
      .flat()
      .find(it => it.id == attrName) as Attribute
  }

  return !!attr?.isMoney
}

export function getIOStyle() {
  return {
    borderRadius: '100%',
    border: `2px solid ${getLineColor()}`,
    zIndex: -1,
    backgroundColor: '#fff',
    height: '16px',
    width: '16px',
  }
}

export function IOHandle(props: {
  color?: string
  id: string
  type: HandleType
  position: Position
  isConnectable?: boolean
  style?: CSSProperties
  hasNext?: boolean
  children?: React.ReactNode
}) {
  const nextStyle = { zIndex: -1 } as KeyValue
  if (props.hasNext === false) {
    nextStyle['bottom'] = '-105px'
    nextStyle.zIndex = 0
  }
  return (
    <Handle
      type={props.type}
      id={props.id}
      position={props.position}
      isConnectable={props.isConnectable == undefined ? true : props.isConnectable}
      style={{
        ...getIOStyle(),
        ...nextStyle,
        opacity: props.color == 'transparent' ? 0 : 1,
        transform: props.position == Position.Bottom ? 'translate(-50%, 4px)' : 'translate(-50%, -4px)',
        ...props.style,
      }}
    >
      {props.children}
    </Handle>
  )
}
